<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
        title="发布讣告"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-cell-group class="martop0">
        <van-field
          v-model="title"
          placeholder="标题"
        />
        <van-field
          v-model="mallcode"
          placeholder="纪念馆编号(选填)"
        />
        <van-field
          v-model="message"
          rows="8"
          type="textarea"
          maxlength="150"
          placeholder="讣告详情..."
        />
      </van-cell-group>
      <div class="btn-area"><van-button class="mybtn" @click="btncommit" size="large">提交</van-button></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Toast } from "vant"
	export default {
	  data() {
	    return {
        title:"",
        mallcode:"",
        message:'先母xxx于公元xxxx年xx月xx日xx市病故，享年八十岁。兹定于xx月xx日x午x时，在xx火葬场火化,并举行追悼会。谨此讣告。 \nxxx哀告 \nxxxx年xx月xx日'
	    };
    },
    computed:{
      ...mapGetters(["currentToken"])
    },
	  components: {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      btncommit(){
        // console.log(this.title, this.mallcode, this.message);
        if (this.title.trim().length<=0){
          Toast("请输入标题");
          return;
        }
        if (this.message.trim().length<=2){
          Toast("请输入讣告详情");
          return;
        }
        var _this = this;
        if (_this.currentToken.isLogin){
          this.$store.dispatch({
            type: "addGenericArticleFG",
            Title : _this.title.trim(),
            MemHallSeriNumber: _this.mallcode.trim(),
            Content: _this.message.trim(),
          }).then(result => {
            console.log(result);
            if(result.IsSuccess){
              // Toast(result.Message);
              window.alert(result.Message);
              _this.$router.go(-1);
            }else{
              Toast(result.Message);
            }
            
          }).catch(ex => {})
        }
        
      }
    }
	};
</script>

<style scoped>

</style>
